enum Actions {
	// action types
	ADD_BODY_CLASSNAME = 'addBodyClassName',
	REMOVE_BODY_CLASSNAME = 'removeBodyClassName',
	ADD_BODY_ATTRIBUTE = 'addBodyAttribute',
	REMOVE_BODY_ATTRIBUTE = 'removeBodyAttribute',
	SET_ERROR = 'actionSetError',
	ADD_CLASSNAME = 'addClassName',
	VERIFY_AUTH = 'verifyAuth',
	LOGIN = 'login',
	LOGOUT = 'logout',
	REGISTER = 'register',
	UPDATE_USER = 'updateUser',
	FORGOT_PASSWORD = 'forgotPassword',
	SET_BREADCRUMB_ACTION = 'setBreadcrumbAction',
	GET_DYNAMIC_LIST = 'actionGetDynamicList',
	GET_DYNAMIC_ENTITY = 'actionGetDynamicEntity',
	SET_ENTITY_ID = 'actionSetEntityID',
	GET_ENTITY_ID = 'actionGetEntityID',
	SAVE_ENTITY = 'actionSaveEntity',
	TRANSFORM_DATA_FOR_REQUEST = 'actionTransformDataForRequest',
	SET_PAGINATION_PARAMS = 'actionSetPaginationParams1',
	SET_MAPPING = 'actionSetFormMap',
	SET_FORM_MAPPING = 'actionSetMap',
	INITIALIZE_FILTER_VALUES = 'actionGetFilters',
	SET_DYNAMIC_LIST = 'actionSetDynamicList',
	CLEAR_FILTER_TAG = 'actionClearFilter',
	SET_SEARCH_TERM = 'actionSetSearchTerm',
	SET_SORT_BY = 'actionSetSortBy',
	SET_PARENT_ID = 'actionSetParentID',
	TOGGLE_IS_MODAL_OPEN = 'actionIsModalOpen',
	SET_FORM_PARENT_ID = 'actionSetFormParentID',
	SET_SUCCESSFULLY_SUBMITTED = 'actionSetSuccessfullySubmitted',
	CLEAR_ENTITY = 'actionClearEntity',
	GET_CLIENT = 'actionGetClient',
	PUSH_PRODUCT_ATTRIBUTE = 'actionPushProductAttribute',
	REMOVE_PRODUCT_ATTRIBUTE = 'actionRemoveProductAttribute',
	SET_FORM_WITH_IMAGE_FLAG = 'actionSetFormWithImage',
	SETUP_LIST = 'actionSetupList',
	SETUP_FORM = 'actionSetUpForm',
	SETUP_FORM_COMPONENT_OR_MODAL = 'actionSetUpFormComponentOrModal',
	INITIALIZE_FORM_VALUES = 'actionInitializeFormValues',
	INITIALIZE_FORM_RELATIONSHIP_LISTS="actionInitializeFormRelationshipList",
	DELETE_ITEM="actionDeleteItem",
	DISABLE_ITEM="actionDisableItem",
	RESET_PAGINATION_PARAMS = 'actionResetPagination',
	
	GET_CATEGORIES = 'actionGetCategories',
	GET_ORDER = 'actionGetOrder',
	GET_PRODUCT_ATTRIBUTE = 'actionGetAttribute',
	SET_APPLIED_FILTERS_VALUES = 'actionSetAppliedFilterValues',
	SET_SORTABLE_LIST_CHANGED = 'actionSetSortableListChanged',
	SET_LIST_ORDER = 'actionSetCategoryChildrenOrder',
	GET_CATALOGUE_PARENT_CATEGORY = 'actionGetCatalogueParentCategory',
	CLEAR_FILTER_MODULE = 'actionClearFilterModule',
	
	SET_FILTERS_VALUE = 'actionSetFIlterValue',
	GET_SALES = 'actionGetSales',
	GET_PRODUCT_SALES = 'actionGetProductSales',
	SET_IS_FROM_LIST = 'actionSetIsFromList',
	SET_FORM_LOADING = 'actionSetFormLoading',
	TOGGLE_IS_MENU_OPEN = 'actionSetToggleIsMenuOpen',

	CALL_CUSTOM_API = "CALL_CUSTOM_API",
}

enum Mutations {
	// mutation types
	SET_CLASSNAME_BY_POSITION = 'appendBreadcrumb',
	PURGE_AUTH = 'logOut',
	SET_AUTH = 'setAuth',
	SET_USER = 'setUser',
	SET_PASSWORD = 'setPassword',
	SET_ERROR = 'setError',
	SET_BREADCRUMB_MUTATION = 'setBreadcrumbMutation',
	SET_LAYOUT_CONFIG = 'setLayoutConfig',
	RESET_LAYOUT_CONFIG = 'resetLayoutConfig',
	OVERRIDE_LAYOUT_CONFIG = 'overrideLayoutConfig',
	OVERRIDE_PAGE_LAYOUT_CONFIG = 'overridePageLayoutConfig',
	SET_DYNAMIC_LIST = 'mutationSetDynamicList',
	SET_DYNAMIC_ENTITY = 'mutationSetDynamicEntity',
	SET_ENTITY_ID = 'mutationSetEntityID',
	SAVE_ENTITY = 'mutationSaveEntity',
	SET_PAGINATION_PARAMS = 'mutationSetPaginationParams',
	SET_MAPPING = 'mutationSetMap',
	SET_FORM_MAPPING = 'mutationSetFormMap',
	SET_FILTERS = 'mutationSetFilters',
	RESET_APPLIED_FILTERS = 'mutationClearFilters',
	CLEAR_FILTER_TAG = 'mutationClearFilter',
	SET_SEARCH_TERM = 'mutationSetSearchTerm',
	SET_VALUES = 'mutationSetValues',
	SET_DYNAMIC_ENTITY_RELATIONSHIPS = 'mutationSetDynamicEntityRelationships',
	SET_SORT_BY = 'mutationSetSortBy',
	SET_PARENT_ID = 'mutationSetParentID',
	TOGGLE_IS_MODAL_OPEN = 'mutationIsModalOpen',
	SET_FORM_PARENT_ID = 'mutationSetFormParentID',
	SET_SUCCESSFULLY_SUBMITTED = 'mutationSetSuccessfullySubmitted',
	SET_CLIENT = 'mutationSetClient',
	SET_ENTITY_KEY = 'mutationSetEntityKey',
	PUSH_PRODUCT_ATTRIBUTE = 'mutationPushProductAttribute',
	REMOVE_PRODUCT_ATTRIBUTE = 'mutationRemoveProductAttribute',
	SET_FORM_WITH_IMAGE_FLAG = 'mutationSetFormWithImage',
	REMOVE_ITEM_FROM_DYNAMIC_LIST = 'mutationRemoveItemFromDynamicList',
	RESET_PAGINATION_PARAMS = 'mutationResetPagination',
	SET_PRODUCT_ATTRIBUTE = 'mutationSetProductAttributes',
	SET_CATEGORIES = 'mutationSetCategories',
	SET_INLINE_SEARCH = 'mutationSetInlineSearch',
	CLEAR_VALUES = 'mutationClearValues',
	SET_ORDER = 'mutationSetOrder',
	
	SET_APPLIED_FILTERS_VALUES = 'mutationSetAppliedFiltersValues',
	SET_APPLIED_FILTER_VALUE = 'mutationSetAppliedFilterValue',
	SET_INITIAL_FILTERS_VALUES = 'mutationSetInitialFilterValues',
	
	SET_FILTERS_VALUE = 'mutationSetFIlterValue',
	SET_DATA_FOR_FILTER_VALUES = 'mutationSetDataForFilterValues',
	SET_SORTABLE_LIST_CHANGED = 'mutationSetSortableListChanged',
	SET_CATALOGUE_PARENT_CATEGORY = 'mutationSetCatalogueParentCategory',
	CLEAR_FORM_MODULE = 'mutationClearFormModule',
	CLEAR_LIST_MODULE = 'mutationClearListModule',
	CLEAR_FILTER_MODULE = 'mutationClearFilterModule',
	SET_SALES = 'mutationSetSales',
	SET_PRODUCT_SALES = 'mutationSetProductSales',
	SET_CLIENT_SALES = 'mutationSetClientSales',
	SET_MONTHLY_SALES = 'mutationSetMonthlySales',
	SET_SALES_FOT_CLIENT = 'mutationSetSalesForClient',
	SET_IS_FROM_LIST = 'mutationSetIsFromList',
	SET_IS_MULTIPLE_UPDATE = 'mutationSetIsMultipleUpdate',
	SET_FORM_LOADING = 'mutationSetFormLoading',
	TOGGLE_IS_MENU_OPEN = 'mutationSetToggleIsMenuOpen',
}
export { Actions, Mutations };
